import { CLICK_IDS } from '@sunflower-games/analytics-events';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';

import Button from '../../../components/buttons/Button';
import { DialogBox } from '../../../components/Dialog/DialogUiRedesign/DialogBox';
import { DialogContent } from '../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogUiRedesign/DialogHeader';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';

import styles from './PocSuccessNotification.module.scss';

export const PocSuccessNotification = observer(function PocSuccessNotification() {
  const { t } = useTranslation();
  const { pocStore, portalStore } = useStores();

  const handleClose = () => {
    void analytics.sendEvent('automatic_poc', {
      step: 'automatic_poc_success',
      event_action: 'click',
      click_id: CLICK_IDS.POC.SUCCESS_NTF,
      triggered_by: 'click',
    });

    portalStore.closePortal();
  };

  useEffectOnce(() => {
    void pocStore.noticePocSuccess();
  });

  return (
    <DialogBox className={styles.box}>
      <DialogHeader title={t('poc.verificationSuccessful')} titleDataTestId="poc-success-title" onClose={handleClose} />
      <DialogContent className={styles.content}>
        <p className={styles.prompt}>
          {t('poc.cardApproved', { cardNumberEnding: pocStore.successNotice?.cardNumberEnding || '????' })}
        </p>
        <Button btnType="main" className={styles.awesomeBtn} dataTestId="poc-success-awesome-btn" onClick={handleClose}>
          {t('buttons.awesome')}
        </Button>
      </DialogContent>
    </DialogBox>
  );
});
